export type MessageButtonAction = 'reload' | 'deposit' | 'cashier' | 'close_message' | 'go_to_home' | 'none' | 'history';

export type MessageText = {id: string;} | string;

export type MessageType = 'error' | 'normal';

export type MessageButton = {
    title: MessageText;
    action: MessageButtonAction;
    actionCallback?: () => void;
};

export type Message = {
    id: string;
    type: MessageType;
    title: MessageText;
    message?: MessageText;
    buttons?: MessageButton[];
    priority?: number;
    withoutBorder?: boolean;
    closeButton?: boolean;
    rendererType?: 'HTML' | 'PIXI';
};